import { HttpEventType, HttpResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { FileUploaders } from '../../enums/file-uploaders.enum';
import { ImagesService } from '../../services/images.service';
import { ProductsSheetService } from '../../services/products-sheet.service';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent {
  @Input() service = FileUploaders.images;
  @Input() multiple = false;
  @Input() uploaderTitle: string;
  @Input() requiredFileType: string;
  @Output() fileUploaded = new EventEmitter();
  uploadProgress: number;
  uploadFinished: boolean;
  uploadSub: Subscription;

  constructor(
    private imagesService: ImagesService,
    private productsSheetService: ProductsSheetService,
    private toasterService: ToastrService,
    private cdk: ChangeDetectorRef
  ) {}

  onFileSelected(event) {
    const filesLength = event.target.files.length;

    const formData = new FormData();

    for (let i = 0; i < filesLength; i++) {
      if (
        this.service === FileUploaders.images &&
        !this.isImage(event.target.files[i])
      ) {
        this.toasterService.error(
          `The file ${event.target.files[i].name} is not a valid`
        );
        return;
      }
      formData.append('file[]', event.target.files[i]);
    }

    const upload$ = this[this.service].uploadFile(formData, this.multiple).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          if (evt.body) {
            this.uploadFinished = true;
            this.toasterService.success('Uploaded Successfully');
            this.fileUploaded.emit(evt.body);
          }
        }
      }),
      finalize(() => this.reset())
    );

    this.uploadSub = upload$.subscribe((e) => {
      if (e.type === HttpEventType.UploadProgress) {
        this.uploadProgress = Math.round(100 * (e.loaded / e.total));
        this.cdk.detectChanges();
      }
    });
  }

  cancelUpload() {
    this.uploadSub.unsubscribe();
    this.reset();
  }

  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
  }

  getFileExtension(file) {
    const parts = file.name.split('.');
    return parts[parts.length - 1];
  }

  isImage(file) {
    const ext = this.getFileExtension(file);
    switch (ext.toLowerCase()) {
      case 'jpg':
      case 'gif':
      case 'bmp':
      case 'png':
      case 'jpeg':
        return true;
    }
    return false;
  }
}
